import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/media/importer/mediaImporterActions'

export default importerReducers(actions)
